import angular from 'angular'
import angularTranslate from 'angular-translate'
import appError from './error'
import appSesion from './sesion'
import appTerminos from './terminos'
import appUi from './ui'

export default angular.module('app', [
  appError,
  appSesion,
  appTerminos,
  appUi,
  angularTranslate,
])



// WEBPACK FOOTER //
// ./src/app/module.js